import { render, staticRenderFns } from "./SalesUpload.vue?vue&type=template&id=4b0f868f&scoped=true"
import script from "./SalesUpload.vue?vue&type=script&lang=js"
export * from "./SalesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f868f",
  null
  
)

export default component.exports